/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in app
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Best Security
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import messages, { MSG_TYPE, MSG_TITLE } from '@/utils/messages';
import repository from '@/repository';
import Router from '@/router';
import helpers from '@/utils/helpers';

export default {
    namespaced: true,
    state: {
        isLoading: false,
        isForceLoading: false,
        isNoLoading: false,
        countLoading: 0,
        isShowHeaderError: false,
        headerErrors: [],
        isShowModalMessage: false,
        modalMessage: {
            type: MSG_TYPE.ERROR,
            title: '',
            content: '',
            okText: 'はい',
            cancelText: 'いいえ',
            callback: () => {}
        },
        header: {
            title: '',
            showBack: false,
            fixBc: false,
            onBack: () => {
                helpers.func_back();
            }
        },
        footer: {
            footerButtons: []
        },
        footerModals: [],
        isShowMenu: false,
        screenId: 'login',
        isDataScreenChange: false,
        isLogout: false,
        isLogin: false,
        user: {},
        menus: [],
        screenAuthority: 0,
        isBacking: false
    },
    getters: {},
    mutations: {
        showLoading(state) {
            state.isLoading = true;
        },
        hideLoading(state) {
            state.isLoading = false;
        },
        showForceLoading(state) {
            state.isForceLoading = true;
        },
        hideForceLoading(state) {
            state.isForceLoading = false;
        },
        showHeaderError(state, errors) {
            state.isShowHeaderError = true;
            state.headerErrors = errors;
        },
        hideHeaderError(state) {
            state.isShowHeaderError = false;
            state.headerErrors = [];
        },
        showModalMessage(state, message) {
            state.isShowHeaderError = false;
            state.headerErrors = [];
            state.isShowModalMessage = true;
            if (message) {
                if (message.type) {
                    state.modalMessage.type = message.type;
                } else {
                    state.modalMessage.type = MSG_TYPE.ERROR;
                }
                state.modalMessage.title = message.title;
                if (message.content) {
                    state.modalMessage.content = message.content;
                } else {
                    state.modalMessage.content = messages.E999;
                }
                if (message.okText) {
                    state.modalMessage.okText = message.okText;
                } else {
                    state.modalMessage.okText = 'はい';
                }
                if (message.cancelText) {
                    state.modalMessage.cancelText = message.cancelText;
                } else {
                    state.modalMessage.cancelText = 'いいえ';
                }
                state.modalMessage.callback = message.callback;
            } else {
                state.modalMessage = {
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E999,
                    content: messages.E999,
                    okText: 'はい',
                    cancelText: 'いいえ',
                    callback: () => {}
                };
            }
        },
        updateShowModalMessage(state, value) {
            state.isShowModalMessage = value;
        },
        hideModalMessage(state) {
            state.isShowModalMessage = false;
            state.modalMessage = {
                type: MSG_TYPE.ERROR,
                title: '',
                content: '',
                okText: 'はい',
                cancelText: 'いいえ',
                callback: () => {}
            };
        },
        setHeader(state, header) {
            state.header.title = header.title;
            state.header.showBack = false;
            if (header.showBack) {
                state.header.showBack = header.showBack;
            }
            state.header.fixBc = false;
            if (header.fixBc) {
                state.header.fixBc = header.fixBc;
            }
            if (header.onBack) {
                state.header.onBack = header.onBack;
            }
            if (header.leftButtons && header.leftButtons.length > 0) {
                state.header.leftButtons = header.leftButtons;
            } else {
                state.header.leftButtons = [];
            }
            if (header.rightButtons && header.rightButtons.length > 0) {
                state.header.rightButtons = header.rightButtons;
            } else {
                state.header.rightButtons = [];
            }
        },
        setFooterFunction(state, footer) {
            if (footer.footerButtons && footer.footerButtons.length > 0) {
                for (let i = 0; i < footer.footerButtons.length; i++) {
                    if (!footer.footerButtons[i].isDisabled)
                        footer.footerButtons[i].isDisabled = false;
                }
            }
            state.footer.footerButtons = footer.footerButtons;
        },
        setFooterModals(state, footerModals) {
            // console.log(footerModals.length);
            // if (footerModals && footerModals.length > 0) {
            //     for (let i = 0; i < footerModals.length; i++) {
            //         console.log(footerModals);
            //         if (!footerModals[i].isDisabled)
            //             footerModals[i].isDisabled = false;
            //     }
            // }
            state.footerModals = footerModals.footerModals;
        },
        showMenu(state) {
            state.isShowMenu = true;
        },
        hideMenu(state) {
            state.isShowMenu = false;
        },
        setAppState(state, data) {
            state.menus = data.menus;
            state.user = data.user;
        },
        resetAppState(state) {
            state.menus = [];
            state.user = {};
        },
        setScreenId(state, id) {
            state.screenId = id;
        },
        setNoLoading(state, val) {
            state.isNoLoading = val;
        },
        increaseCountLoading(state) {
            state.countLoading += 1;
        },
        decreaseCountLoading(state) {
            state.countLoading -= 1;
            if (state.countLoading < 0) {
                state.countLoading = 0;
            }
        },
        setMobile(state, isMobile) {
            state.isMobile = isMobile;
        },
        setDataScreenChange(state, data) {
            state.isDataScreenChange = data;
        },
        setLogout(state, data) {
            state.isLogout = data;
        },
        setLogin(state, data) {
            state.isLogin = data;
        },
        setScreenAuthority(state, data) {
            state.screenAuthority = data;
        },
        setBacking(state, data) {
            state.isBacking = data;
        }
    },
    actions: {
        getAppState(context) {
            try {
                repository.getAppState({}).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        context.commit('setAppState', data.Data ?? {});
                    }
                });
            } catch (e) {
                console.log('Action getAppState: ' + e.message);
            }
        },
        setScreenId(context, screenid) {
            try {
                // if (context.state.screenId != screenid) {
                if (screenid) {
                    context.commit('setScreenId', screenid);
                    repository.checkScreenAuthority(screenid).then((res) => {
                        const { data } = res;
                        if (data.Code === 200) {
                            if (data.Data.screenauthority == 0) {
                                Router.push({ name: 'Bs002000i' });
                            } else {
                                context.commit(
                                    'setScreenAuthority',
                                    data.Data.screenauthority
                                );
                            }
                        }
                    });
                }
            } catch (e) {
                console.log('Action setScreenId: ' + e.message);
            }
        }
    }
};
